import Rx from 'rxjs/Rx';

export default class PasswordRecoveryService {
  constructor($http, host) {
    this.http = $http;
    this.host = host;
   }

  changePassword(password, token){
    return Rx.Observable.fromPromise(this.http({
      method: 'PUT',
      url: this.host + '/api/password-recovery/' + token,
      data: {password: password}
    }));
  }

  requestPassword(email){
    return Rx.Observable.fromPromise(this.http({
      method: 'POST',
      url: this.host + '/api/password-recovery',
      data: {email: email}
    }));
  }

}

 PasswordRecoveryService.$inject = ['$http', 'host'];



// WEBPACK FOOTER //
// ./src/app/services/password-recovery.service.js